import { render } from "./required-change-password-msg-box.vue?vue&type=template&id=01a699b4&scoped=true&ts=true"
import script from "./required-change-password-msg-box.vue?vue&type=script&lang=ts"
export * from "./required-change-password-msg-box.vue?vue&type=script&lang=ts"

import "./required-change-password-msg-box.vue?vue&type=style&index=0&id=01a699b4&lang=scss&scoped=true"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a699b4"]])

export default __exports__